import { EventNames } from 'state/analytics/types';

interface IAdobeEventRequiredFields {
  event: EventNames;
  _timhortons: {
    platform: 'web';
    loyalty: {
      id: string | null;
    };
  };
}

export type IAdobeEvent<T extends Record<string, any>> = IAdobeEventRequiredFields & T;

export enum ElementType {
  BUTTON = 'button',
}

interface GtmEvent {
  event: string;
  brand: string;
  timestamp: number;
  duration: number;
  platform: string;
}

export type TGTMDataLayer = (GtmEvent | IAdobeEvent<Record<string, any>>)[];
